import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

export default class JobFullDetailsCallDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      isSpinnerLoading: false,
      currentUser:null,
      CompoundOnSite:"",
      //CloseTime:"",
      CustomerName:"",
      CustomerSurname:"",
      CustomerEmail:"driver@cargoes.trax-app.net",
      readOnly:false,
      latestCollectionTime:"",
      carNotOnSiteSelectedOption:"Taken by another company",
      callNotes:"",
      showNextCallBox:false,
      addCallCackInfo:""
    };
    this.handleCompoundOnSiteChange = this.handleCompoundOnSiteChange.bind(this);
    //this.handleCloseTimeChange = this.handleCloseTimeChange.bind(this);
    this.handleCustomerNameChange = this.handleCustomerNameChange.bind(this);
    this.handleCustomerSurnameChange = this.handleCustomerSurnameChange.bind(this);
    this.handleCustomerEmailChange = this.handleCustomerEmailChange.bind(this);
    this.handleLatestCollectionTimeChange = this.handleLatestCollectionTimeChange.bind(this);
    this.onIsTheCarNotOnSiteChange = this.onIsTheCarNotOnSiteChange.bind(this);
    this.handleCallNotesChange = this.handleCallNotesChange.bind(this);
  }

  componentDidMount() {
    fetch('/current-user', {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((res) => {
        this.setState({currentUser:res});
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
    if (this.state.data) {
      let callDetails = this.state.data.call_details;
      callDetails = JSON.parse(callDetails);
      if((callDetails != null && callDetails.add_call_back_info != null)){
        this.setState({showNextCallBox:true});
      }
    }
  }
  handleCompoundOnSiteChange(e){
    this.setState({CompoundOnSite:e.target.value});
  }
  // handleCloseTimeChange(e){
  //   this.setState({CloseTime:e.target.value});
  // }
  handleCustomerNameChange(e){
    this.setState({CustomerName:e.target.value});
  }
  handleCustomerSurnameChange(e){
    this.setState({CustomerSurname:e.target.value});
  }
  handleCallNotesChange(e){
    this.setState({callNotes:e.target.value});
  }
  handleCustomerEmailChange(e){
    this.setState({CustomerEmail:e.target.value});
  }
  onIsTheCarOnSiteChange(e){
    if(e.target.checked) {
      if(e.target.value == 0){
        $('.is-the-car-on-site-dropdown-block').removeClass('toggle-hide').addClass('toggle-show');
      }else{
       $('.is-the-car-on-site-dropdown-block').removeClass('toggle-show').addClass('toggle-hide');
      }
   }
  }
  
  onIsTheVehicleElectricChange(e) {
    if(e.target.checked) {
       if(e.target.value == 1){
         $('.is-the-vehicle-fully-charged-form-radio-block').removeClass('toggle-hide').addClass('toggle-show');
       }else{
        $('.is-the-vehicle-fully-charged-form-radio-block').removeClass('toggle-show').addClass('toggle-hide');
       }
    }
  }
  onIsTheCarNotOnSiteChange(e){
    this.setState({carNotOnSiteSelectedOption:e.target.value});
  }
  handleLatestCollectionTimeChange(e){
    this.setState({latestCollectionTime:e.target.value});
  }
  
  handleSaveCallDetailsClick(e){
    let msg = "";
    let is_the_car_on_site = "";
    let is_the_vehicle_electric = "";
    let is_the_vehicle_fully_charged ="";
    let is_ready_for_collection = "";
    var regx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    // if(this.state.CompoundOnSite == ""){
    //   msg += 'Please fill compound on site.\n<br>';
    // }
    // if(this.state.CloseTime == ""){
    //   msg += 'Please fill closing site.\n';
    // }
    // if(this.state.CustomerName == ""){
    //   msg += 'Please fill Customer Name.\n<br>';
    // }
    // if(this.state.CustomerSurname == ""){
    //   msg += 'Please fill Customer Surname.\n<br>';
    // }
    // if(this.state.CustomerEmail == ""){
    //   msg += 'Please fill Customer Email.\n<br>';
    // }
    // if(!(regx.test(this.state.CustomerEmail))){
    //   msg += 'Please fill proper Customer Email.\n<br>';
    // }

    if ($("input[name='is_the_car_on_site']").is(":checked")){
      is_the_car_on_site = document.querySelector('#is-the-car-on-site-radio-container '+'label [name=is_the_car_on_site]:checked').value;
    }else{
      msg += 'Please check is the car on site ?\n<br>'
    }

    // if ($("input[name='is_the_car_on_site']").is(":checked")){
    //   is_ready_for_collection = document.querySelector('#is-ready-for-collection-radio-container '+'label [name=is_ready_for_collection]:checked').value;
    // }else{
    //   msg += 'Please check is it ready for collection ?\n<br>'
    // }

    // if(this.state.latestCollectionTime == ""){
    //   msg += 'Please fill latest time we can collect ?.\n<br>';
    // }
    
    // if ($("input[name='is_the_vehicle_electric']").is(":checked")){
    //   is_the_vehicle_electric = document.querySelector('#is-the-vehicle-electric-radio-container '+'label [name=is_the_vehicle_electric]:checked').value;
    //   if(is_the_vehicle_electric == 1){
    //     if ($("input[name='is_the_vehicle_fully_charged']").is(":checked")){
    //       is_the_vehicle_fully_charged = document.querySelector('#is-the-vehicle-fully-charged-radio-container '+'label [name=is_the_vehicle_fully_charged]:checked').value;
    //     }else{
    //       msg += 'Please check vehicle is fully charged ?\n<br>';
    //     }
    //   }
    // }else{
    //   msg += 'Please check vehicle is electric ?\n<br>';
    // }
    
    if(msg == ""){ 
      this.setState({isSpinnerLoading:true});
      let jobId = this.state.data.id;
      return fetch(
        '/api/v1/portal/jobs/save-call-details/' + jobId,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify(
            {
              compound_on_site:this.state.CompoundOnSite,
              //close_time:this.state.CloseTime,
              customer_name:this.state.CustomerName,
              customer_surname:this.state.CustomerSurname,
              customer_email:this.state.CustomerEmail,
              call_info_filled_by:this.state.currentUser.full_name,
              call_info_filled_from:this.state.currentUser.company.short_name,
              registration_plate:this.state.data.vehicle.registration_number,
              is_the_car_on_site:is_the_car_on_site,
              is_ready_for_collection:is_ready_for_collection,
              car_not_on_site_selected_option:this.state.carNotOnSiteSelectedOption,
              latest_collection_time:this.state.latestCollectionTime,
              is_the_vehicle_electric:is_the_vehicle_electric,
              is_the_vehicle_fully_charged:is_the_vehicle_fully_charged,
              call_notes:this.state.callNotes
            }
          )
        }
      ).then((responseText) => {
        let response = responseText.json();
        response.then((res) => {
          if(res.confirmedOnSite){
            $('.save-call-details-btn').hide();
            let infoModal = $('#infomodal');
            document.querySelector('#infomodallabel').innerHTML = 'Call Details';
            document.querySelector('#infomodal .modal-body').innerHTML = res.success;
            infoModal.modal();
          }
        });
      }).catch((error)=>{
        $('.save-call-details-btn').hide();
        let infoModal = $('#infomodal');
        document.querySelector('#infomodallabel').innerHTML = 'Call Details';
        document.querySelector('#infomodal .modal-body').innerHTML = res.success;
        infoModal.modal();
      });
    }else{
      let infoModal = $('#infomodal');
      document.querySelector('#infomodallabel').innerHTML = 'Call Details';
      document.querySelector('#infomodal .modal-body').innerHTML = msg;
      infoModal.modal();
    }
  }
  handleSaveNeedCallBackInfo(){
      let jobId = this.state.data.id;
      let newJobData ={
        api_token: window.api_token,
        add_call_back_info: this.state.addCallCackInfo,
      };
      $.ajax({
        type: "POST",
        url: '/api/v1/portal/jobs/save-need-callback-info/' + jobId,
        data: newJobData,
        dataType: "text/json",
        complete: function(response) {
          let infoModal = $('#infomodal');
          if (response.status === 200) {
            $('#infomodallabel').html('Success');
            $('#infomodal .modal-body').html(
              $.parseHTML(
                response.responseText.replace(/\"/g,
                ""))
            );
            infoModal.modal();
          }
          else {
            $('#infomodallabel').html('Error');
            $('#infomodal .modal-body').html(
              $.parseHTML(
                response.responseText.replace(/\"/g,
                ""))
            );
            infoModal.modal();
          }
        }
      });
  }
  render() {
    let jobId = "";
    let registrationPlate = "";
    let adminName = "";
    let companyName = "";
    let vehicleMake = "";
    let vehicleModle = "";
    let callDetails = null;
    if (this.state.data) {
      jobId = this.state.data.id;
      registrationPlate = this.state.data.vehicle.registration_number;
      vehicleMake = this.state.data.vehicle.make;
      vehicleModle = this.state.data.vehicle.model;
      callDetails = this.state.data.call_details;
      callDetails = JSON.parse(callDetails);
    }
    if(this.state.currentUser){
      adminName = (callDetails != null && callDetails.call_info_filled_by != '') ? callDetails.call_info_filled_by : this.state.currentUser.full_name;
      companyName = this.state.currentUser.company.short_name;
    }
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="subsection-container row">
                <div className="col-md-9">
                    <div className="call-details-message">
                    <p>Good morning/afternoon, this is <b>{adminName}</b> calling from <b>{companyName}</b>.
                      please can I speak to the relevant person regarding a vehicle collection.</p>
                    <p>The vehicle <b>{registrationPlate}</b> is a <b>{vehicleMake}</b> and <b>{vehicleModle}</b>.</p>
                    
                    <div className="is-the-car-on-site-form-radio-block">
                      <label>Is the car on site ?</label>
                      <div className="" id="is-the-car-on-site-radio-container">
                        <label className="" id="yes-the-car-on-site">
                              <input className=""
                              name="is_the_car_on_site"
                              type="radio"
                              defaultChecked={(callDetails != null && callDetails.is_the_car_on_site == '1') ? true:false}
                              disabled={(callDetails != null && callDetails.is_the_car_on_site == '1') ? true:false}
                              onChange={this.onIsTheCarOnSiteChange}
                              value="1" /> YES &nbsp;&nbsp;
                        </label>
                        <label className="" id="no-the-car-not-on-site">
                              <input className=""
                                name="is_the_car_on_site"
                                onChange={this.onIsTheCarOnSiteChange}
                                defaultChecked={(callDetails != null && callDetails.is_the_car_on_site == '0') ? true:false}
                                disabled={(callDetails != null && callDetails.is_the_car_on_site == '0') ? true:false}
                                type="radio" value="0" /> NO
                        </label>
                      </div>
                    </div>

                    <div className={(callDetails != null && callDetails.is_the_car_on_site == "0" && callDetails.car_not_on_site_selected_option != "") ? 'is-the-car-on-site-dropdown-block toggle-show':'is-the-car-on-site-dropdown-block toggle-hide'}>
                      <div className="row">
                          <p>Where is the vehicle?
                            <select className="form-control form-control-lg" 
                              onChange={this.onIsTheCarNotOnSiteChange}
                              disabled={(callDetails != null && callDetails.is_the_car_on_site != "" && callDetails.car_not_on_site_selected_option != "") ? 'disabled':''}
                              value={(callDetails != null && callDetails.is_the_car_on_site != "" && callDetails.car_not_on_site_selected_option != "") ? callDetails.car_not_on_site_selected_option:this.state.carNotOnSiteSelectedOption}>
                              <option value="Taken by another company">Taken by another company</option>
                              <option value="No MOT">No MOT</option>
                              <option value="In bodyshop">In bodyshop</option>
                              <option value="Out with Driver">Out with Driver</option>
                            </select>
                          </p>
                      </div>
                    </div>

                    <div className="is-the-car-on-site-form-radio-block">
                      <label>Is it ready for collection ?</label>
                      <div className="" id="is-ready-for-collection-radio-container">
                        <label className="" id="yes-the-car-on-site">
                              <input className=""
                              name="is_ready_for_collection"
                              type="radio"
                              defaultChecked={(callDetails != null && callDetails.is_ready_for_collection == '1') ? true:false}
                              disabled={(callDetails != null && callDetails.is_ready_for_collection == '1') ? true:false}
                              value="1" /> YES &nbsp;&nbsp;
                        </label>
                        <label className="" id="no-the-car-not-on-site">
                              <input className=""
                                name="is_ready_for_collection"
                                defaultChecked={(callDetails != null && callDetails.is_ready_for_collection == '0') ? true:false}
                                disabled={(callDetails != null && callDetails.is_ready_for_collection == '0') ? true:false}
                                type="radio" value="0" /> NO
                        </label>
                      </div>
                    </div>

                    <hr/>
                    <p>
                      Do you have a compound on site?&nbsp;
                      <input 
                        onChange={this.handleCompoundOnSiteChange} 
                        className="form-control form-control-lg half-width" 
                        type="text" 
                        placeholder="compound on site ?" 
                        required 
                        readOnly={(callDetails != null) ? true : false}
                        value={(callDetails != null && callDetails.compound_on_site != "") ? callDetails.compound_on_site : this.state.CompoundOnSite}
                      />
                    </p>
                    {/* <p>
                      What time do you open?&nbsp;
                      <input 
                        onChange={this.handleCloseTimeChange} 
                        className="form-control form-control-lg half-width" 
                        type="text" 
                        placeholder="HH:MM" 
                        required readOnly={(this.state.data.confirmed_on_site) ? true : false}
                        value={(callDetails != null && callDetails.close_time != "") ? callDetails.close_time : this.state.CloseTime}
                        />
                    </p> */}
                    <p>
                      What is the latest time we can collect?&nbsp;
                      <input 
                        onChange={this.handleLatestCollectionTimeChange} 
                        className="form-control form-control-lg half-width" 
                        type="text" 
                        placeholder="HH:MM" 
                        required readOnly={(callDetails != null) ? true : false}
                        value={(callDetails != null && callDetails.latest_collection_time != "") ? callDetails.latest_collection_time : this.state.latestCollectionTime}
                        />
                    </p>

                    <div className="is-the-vehicle-electric-form-radio-block">
                      <label>Is the vehicle electric?</label>
                      <div className="" id="is-the-vehicle-electric-radio-container">
                        <label className="" id="yes-the-vehicle-electric">
                              <input className=""
                              defaultChecked={(callDetails != null && callDetails.is_the_vehicle_electric  == '1') ? true:false}
                              name="is_the_vehicle_electric"
                              type="radio"
                              onChange={this.onIsTheVehicleElectricChange}
                              value="1" /> YES&nbsp;&nbsp;
                        </label>
                        <label className="" id="no-the-vehicle-not-electric">
                              <input className=""
                                name="is_the_vehicle_electric"
                                defaultChecked={(callDetails != null && callDetails.is_the_vehicle_electric  == '0') ? true:false}
                                onChange={this.onIsTheVehicleElectricChange}
                                type="radio" value="0" /> NO
                        </label>
                      </div>
                    </div>

                    <div className={(callDetails != null && callDetails.is_the_vehicle_electric  == '1') ? 'is-the-vehicle-fully-charged-form-radio-block toggle-show':'is-the-vehicle-fully-charged-form-radio-block toggle-hide'}>
                      <label>Is the vehicle fully charged?</label>
                      <div id="is-the-vehicle-fully-charged-radio-container">
                        <label id="yes-the-vehicle-fully-charged">
                              <input 
                              defaultChecked={(callDetails != null && callDetails.is_the_vehicle_fully_charged  == '1') ? true:false}
                              name="is_the_vehicle_fully_charged"
                              type="radio"
                              value="1" /> YES &nbsp;&nbsp;
                        </label>
                        <label id="no-the-vehicle-not-fully-charged">
                              <input
                                name="is_the_vehicle_fully_charged"
                                defaultChecked={(callDetails != null && callDetails.is_the_vehicle_fully_charged  == '0') ? true:false}
                                type="radio" value="0" /> NO
                        </label>
                      </div>
                      
                    </div>
                    <hr/>
                    <p>
                      Call in notes ?
                      <input 
                        onChange={this.handleCallNotesChange} 
                        className="form-control form-control-lg half-width" 
                        type="text" 
                        placeholder="notes" 
                        required readOnly={(callDetails != null) ? true : false}
                        value={(callDetails != null && callDetails.call_notes != "") ? callDetails.call_notes : this.state.callNotes}
                        />
                    </p>
                    <p>That's great, thank you.</p>
                    <p>
                      Please can I take your name?&nbsp; 
                      <input 
                        onChange={this.handleCustomerNameChange}  
                        className="form-control form-control-lg half-width" 
                        type="text" 
                        placeholder="customer name" 
                        required 
                        readOnly={(callDetails != null) ? true : false}
                        value={(callDetails != null && callDetails.customer_name != "") ? callDetails.customer_name : this.state.CustomerName}
                        />
                    </p>
                    <p>
                      Please can I take your surname?&nbsp; 
                      <input 
                        onChange={this.handleCustomerSurnameChange}  
                        className="form-control form-control-lg half-width" 
                        type="text" 
                        placeholder="customer surname" 
                        required 
                        readOnly={(callDetails != null) ? true : false}
                        value={(callDetails != null && callDetails.customer_surname != "") ? callDetails.customer_surname : this.state.CustomerSurname}
                        />
                    </p>
                    <p>
                      and your email address&nbsp; 
                      <input 
                        onChange={this.handleCustomerEmailChange} 
                        className="form-control form-control-lg half-width" 
                        type="email" 
                        placeholder="customer email address" 
                        required 
                        readOnly={(callDetails != null) ? true : false}
                        value={(callDetails != null && callDetails.customer_email != "") ? callDetails.customer_email : this.state.CustomerEmail}
                        />
                    </p>
                    <p>Thank you, goodbye.</p>
                    {(callDetails == null) ? 
                      <button className="btn btn-primary btn-lg save-call-details-btn" onClick={(e) => {this.handleSaveCallDetailsClick()}}  disabled={(this.state.isSpinnerLoading) ? 'disabled':''}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Save Details &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button> : "" }
                      <br/>
                      <div id="msg-after-submit"></div>
                      { (callDetails != null && this.state.data.confirmed_on_site_date_time) ? 
                        <p className={(callDetails != null && callDetails.is_the_car_on_site == '1') ? 'alert alert-success' : 'alert alert-danger'}><i className="text-right"><b>Confirmed on:-</b> { moment(this.state.data.confirmed_on_site_date_time).format('ddd Do MMM YYYY - HH:mm:ss').toString()} </i></p>
                        : ""
                      }
                      
                  </div>
                </div>
                <div className="col-md-3 text-right">
                  <div className="call-details-message">
                    <button className="btn btn-success btn-lg" onClick={(e) => {this.setState({showNextCallBox:!this.state.showNextCallBox})}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Need Call Back ? &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                    <br/>
                    <br/>
                    {this.state.showNextCallBox ?
                      <div>
                        <p className="text-left">
                          Add call back information :&nbsp;
                          <textarea className="form-control form-control-lg"
                                rows="5"
                                name="add_call_back_info"
                                id="add_call_back_info"
                                placeholder="Add call back information" 
                                required 
                                onChange={(e)=>{this.setState({addCallCackInfo:e.target.value})}} 
                                defaultValue={(callDetails != null && callDetails.add_call_back_info != "") ? callDetails.add_call_back_info : this.state.addCallCackInfo}>
                          </textarea>
                        </p>
                        <button className="btn btn-primary btn-lg" onClick={(e) => this.handleSaveNeedCallBackInfo()}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Save &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                      </div>
                      : ''
                    }
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}